var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5993 4.2483C15.5765 4.2483 16.3686 3.43408 16.3686 2.42969C16.3686 1.4253 15.5765 0.611084 14.5993 0.611084C13.6222 0.611084 12.8301 1.4253 12.8301 2.42969C12.8301 3.43408 13.6222 4.2483 14.5993 4.2483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1378 15.2996C14.438 15.4215 14.7781 15.4215 15.0707 15.282C15.243 15.1997 15.4172 15.0629 15.5192 14.8348C15.5319 14.807 15.5476 14.7802 15.5592 14.7517L18.8586 6.60258C18.8586 6.60258 19.5516 4.97436 17.8685 5.43217C17.8685 5.43217 14.4892 7.23489 11.2381 5.38125C11.1971 5.3576 11.1536 5.33898 11.1084 5.32577C10.8469 5.25026 10.0239 5.09665 10.2328 6.23377C10.2407 6.27585 10.2529 6.31698 10.269 6.35649L13.6391 14.7552C13.6518 14.7868 13.722 14.9154 13.7409 14.9436C13.8107 15.0485 13.8734 15.1923 14.1378 15.2996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44309 4.2483C5.42023 4.2483 6.21236 3.43408 6.21236 2.42969C6.21236 1.4253 5.42023 0.611084 4.44309 0.611084C3.46595 0.611084 2.67383 1.4253 2.67383 2.42969C2.67383 3.43408 3.46595 4.2483 4.44309 4.2483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86214 5.36295C4.56197 5.2411 4.2218 5.2411 3.92903 5.3808C3.75693 5.46283 3.58272 5.59969 3.48047 5.82772C3.46798 5.85579 3.45211 5.88234 3.44068 5.91084L0.141355 14.0602C0.141355 14.0602 -0.551702 15.6884 1.13141 15.2304C1.13141 15.2304 4.51075 13.4279 7.7618 15.2815C7.80275 15.3051 7.84622 15.3236 7.89136 15.3368C8.153 15.4123 8.97603 15.5659 8.7671 14.4288C8.75912 14.3868 8.74692 14.3457 8.73069 14.3063L5.36235 5.90823C5.3315 5.84364 5.29752 5.78068 5.26053 5.71958C5.1892 5.61405 5.12654 5.47022 4.86214 5.36295Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 14.7778,
    fill: "white",
    transform: "translate(0 0.611084)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.ce5cdf26c4923bcfee63fc671dd240f7.svg";
export { ForwardRef as ReactComponent };